import atoms from '@Components/Utilities/SandhillsAtoms';
import Button from '@mui/material/Button';
import Modal from '@Components/Shared/Modals/Modal';
import translator from '@Components/Utilities/Translator';
import { useRecoilValue } from 'recoil';
import { useState } from 'react';
import { loadable } from '@Components/Utilities/SandhillsLoadable';
import FTIInformation from '@Components/Account/FTIInformation';

const FTIInformationModal = (props) => {

    const routes = useRecoilValue(atoms.routes);
    const currentUser = useRecoilValue(atoms.currentUser);
    const FeedbackModal = loadable(() => import('@Components/Shared/Modals/FeedbackModal'), true);

    const [showFTIModal, setShowFTIModal] = useState(true);
    const toggleFTIModal = () => setShowFTIModal(showFTIModal => !showFTIModal);
    const [showFeedbackModal, setShowFeedbackModal] = useState(false);
    const toggleFeedbackModal = () => setShowFeedbackModal(showFeedbackModal => !showFeedbackModal);

    const requestAccessBtnOnClick = () => {
        toggleFTIModal();
        toggleFeedbackModal();
    };

    return (
        <div>
            {showFTIModal &&
                <Modal containerClassName='buyers-premium-modal' contentClassName='fti-info-modal' onEscapeKeyClose={props.onClose}>
                    <Modal.Header onClose={props.onClose}>
                        <div className='fti-header'><img src={routes.CDNBaseUrl + 'Images/Logos/FastTrack/fti-logo.png'} alt='Fast Track Iron' /></div>
                    </Modal.Header>
                    <Modal.Body>
                        <FTIInformation {...props} onClick={requestAccessBtnOnClick} onClose={props.onClose} isModal={true} />
                    </Modal.Body>
                </Modal>
            }
            { showFeedbackModal &&
                <FeedbackModal
                    {...props?.FTIModal}
                    toggleModal={toggleFeedbackModal}
                    title={translator.translate('sandhills.requestwholesaleaccess')}
                />
            }
        </div>
    );
};

export default FTIInformationModal;